import throttle from 'lodash/throttle';

export const FETCH_THROTTLE_TIME = 5000;

const getThrottleFetchFunction = (
  fetchFunction,
  debounceTime = FETCH_THROTTLE_TIME
) => throttle(fetchFunction, debounceTime, { leading: true, trailing: true });

export default getThrottleFetchFunction;
